import palette from '../palette';

const { gray, clear_blue, white } = palette;

const colors = {
  Layout: {
    header_background: gray.dark,
    header_color: white,
    link_color: clear_blue,
    content_color: gray.light,
  },
};

export default colors;
